import React from 'react';

import './AdminModalButton.css';

const AdminModalButton = React.forwardRef(
  ({ children, type, onClick, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className='admin-modal-btn'
        type={type}
        onClick={onClick}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

export default AdminModalButton;
